export default __webpack_public_path__ + "static/media/times.42a8881f.ttf";